export default "__VITE_ASSET__5rHiRlkp__"